import { ProductResponse } from 'src/admin-entity/interface/chat-product/chat-product.interface';

export interface LiveProductInitType {
    items: ProductResponse[];
}

export const initialState: LiveProductInitType = {
    items: [],
};
